'use client';

import Card1 from '../../../textContent/erpnext/Card1.json';
import Card2 from '../../../textContent/erpnext/Card2.json';
import Card3 from '../../../textContent/erpnext/Card3.json';
import Card4 from '../../../textContent/erpnext/Card4.json';
import Card5 from '../../../textContent/erpnext/Card5.json';
import DisaHero from '@/components/DisaHero';
import { Fragment } from 'react';
import Heading from '../../../textContent/erpnext/Data1.json';
import Rocket from '@/components/Rocket';
import VideoTextCard from '@/components/VideoTextCard';
import cardData from '../../../textContent/manufacturing/cardOne.json';
import { motion } from 'framer-motion';
import rocketTextContent from '@/textContent/rocket/rocket3.json';

const page = () => {
    /* ---------------- Animation Variants ---------------- */

    const fadeUp = {
        hidden: { opacity: 0, y: 50 },
        visible: (delay = 0) => ({
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.7,
                ease: 'easeOut',
                delay,
            },
        }),
    };
    return (
        <Fragment>
            {/* HERO */}
            <motion.div variants={fadeUp} initial="hidden" animate="visible">
                <DisaHero {...Heading.maintext} />
            </motion.div>

            {/* VIDEO + TEXT */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={cardData} />
            </motion.div>
            {/* CARD 1 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={Card1} />
            </motion.div>
            {/* CARD 2 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={Card2} />
            </motion.div>

            {/* CARD 3 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={Card3} />
            </motion.div>

            {/* CARD 4 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={Card4} />
            </motion.div>

            {/* CARD 5 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={Card5} />
            </motion.div>

            {/* ROCKET CTA */}
            <motion.div
                id="iconss"
                className="flex items-center justify-center my-10"
                initial={{ opacity: 0, scale: 0.85 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
            >
                <Rocket jsonData={rocketTextContent} />
            </motion.div>
        </Fragment>
    );
};

export default page;
